module.exports = __webpack_public_path__ + "img/t1-i4.04d88ccb.jpg";